import React from 'react';
import { Shield, Target, Globe } from 'lucide-react';
import { PageLayout } from '../components/PageLayout';
import { Card } from '../components/Card';
import { SEO } from '../components/SEO';
import { useLanguage } from '../hooks/useLanguage';
export function AboutPage() {
  const {
    t
  } = useLanguage();
  return <>
      <SEO title={t('seo.about.title')} description={t('seo.about.desc')} data-id="element-288" />
      <PageLayout title={t('about.title')} subtitle={t('about.subtitle')} icon={<Shield className="h-8 w-8 text-primary-600" data-id="element-290" />} maxWidth="lg" data-id="element-289">
        {/* Mission */}
        <Card className="mb-8 animate-fade-in" data-id="element-291">
          <div className="flex items-start gap-4" data-id="element-292">
            <div className="flex-shrink-0 p-3 bg-accent-50 rounded-xl" data-id="element-293">
              <Target className="h-6 w-6 text-accent-600" data-id="element-294" />
            </div>
            <div data-id="element-295">
              <h2 className="text-2xl font-bold mb-3 text-primary-900" data-id="element-296">
                {t('about.ourMission')}
              </h2>
              <p className="text-slate-700 leading-relaxed" data-id="element-297">
                {t('about.mission.text')}
              </p>
            </div>
          </div>
        </Card>

        {/* What We Do */}
        <Card className="mb-8 animate-fade-in delay-100" data-id="element-298">
          <h2 className="text-2xl font-bold mb-6 text-primary-900" data-id="element-299">
            {t('about.whatWeProvide')}
          </h2>
          <div className="space-y-4" data-id="element-300">
            <div className="flex items-start gap-3" data-id="element-301">
              <div className="w-2 h-2 rounded-full bg-accent-600 mt-2 flex-shrink-0" data-id="element-302" />
              <div data-id="element-303">
                <h3 className="font-semibold mb-1 text-primary-900" data-id="element-304">
                  {t('about.provide.emergency.title')}
                </h3>
                <p className="text-slate-600 text-sm leading-relaxed" data-id="element-305">
                  {t('about.provide.emergency.desc')}
                </p>
              </div>
            </div>
            <div className="flex items-start gap-3" data-id="element-306">
              <div className="w-2 h-2 rounded-full bg-accent-600 mt-2 flex-shrink-0" data-id="element-307" />
              <div data-id="element-308">
                <h3 className="font-semibold mb-1 text-primary-900" data-id="element-309">
                  {t('about.provide.types.title')}
                </h3>
                <p className="text-slate-600 text-sm leading-relaxed" data-id="element-310">
                  {t('about.provide.types.desc')}
                </p>
              </div>
            </div>
            <div className="flex items-start gap-3" data-id="element-311">
              <div className="w-2 h-2 rounded-full bg-accent-600 mt-2 flex-shrink-0" data-id="element-312" />
              <div data-id="element-313">
                <h3 className="font-semibold mb-1 text-primary-900" data-id="element-314">
                  {t('about.provide.reporting.title')}
                </h3>
                <p className="text-slate-600 text-sm leading-relaxed" data-id="element-315">
                  {t('about.provide.reporting.desc')}
                </p>
              </div>
            </div>
            <div className="flex items-start gap-3" data-id="element-316">
              <div className="w-2 h-2 rounded-full bg-accent-600 mt-2 flex-shrink-0" data-id="element-317" />
              <div data-id="element-318">
                <h3 className="font-semibold mb-1 text-primary-900" data-id="element-319">
                  {t('about.provide.education.title')}
                </h3>
                <p className="text-slate-600 text-sm leading-relaxed" data-id="element-320">
                  {t('about.provide.education.desc')}
                </p>
              </div>
            </div>
          </div>
        </Card>

        {/* What We Don't Do */}
        <Card className="mb-8 bg-red-50 border-2 border-red-200 animate-fade-in delay-200" data-id="element-321">
          <h2 className="text-2xl font-bold mb-4 text-red-900" data-id="element-322">
            {t('about.whatWeDontDo')}
          </h2>
          <ul className="space-y-3 text-red-800" data-id="element-323">
            <li className="flex items-start gap-2" data-id="element-324">
              <span className="text-red-600 font-bold" data-id="element-325">✗</span>
              <span data-id="element-326">{t('about.dontDo.reports')}</span>
            </li>
            <li className="flex items-start gap-2" data-id="element-327">
              <span className="text-red-600 font-bold" data-id="element-328">✗</span>
              <span data-id="element-329">{t('about.dontDo.store')}</span>
            </li>
            <li className="flex items-start gap-2" data-id="element-330">
              <span className="text-red-600 font-bold" data-id="element-331">✗</span>
              <span data-id="element-332">{t('about.dontDo.replace')}</span>
            </li>
            <li className="flex items-start gap-2" data-id="element-333">
              <span className="text-red-600 font-bold" data-id="element-334">✗</span>
              <span data-id="element-335">{t('about.dontDo.legal')}</span>
            </li>
          </ul>
        </Card>

        {/* Coverage */}
        <Card className="animate-fade-in delay-300" data-id="element-336">
          <div className="flex items-start gap-4" data-id="element-337">
            <div className="flex-shrink-0 p-3 bg-accent-50 rounded-xl" data-id="element-338">
              <Globe className="h-6 w-6 text-accent-600" data-id="element-339" />
            </div>
            <div data-id="element-340">
              <h2 className="text-2xl font-bold mb-3 text-primary-900" data-id="element-341">
                {t('about.aseanCoverage')}
              </h2>
              <p className="text-slate-700 leading-relaxed mb-6" data-id="element-342">
                {t('about.coverageDesc')}
              </p>
              <div className="grid grid-cols-2 sm:grid-cols-3 gap-3" data-id="element-343">
                <div className="text-sm text-slate-700 font-medium" data-id="element-344">
                  🇮🇩 Indonesia
                </div>
                <div className="text-sm text-slate-700 font-medium" data-id="element-345">
                  🇲🇾 Malaysia
                </div>
                <div className="text-sm text-slate-700 font-medium" data-id="element-346">
                  🇹🇭 Thailand
                </div>
                <div className="text-sm text-slate-700 font-medium" data-id="element-347">
                  🇻🇳 Vietnam
                </div>
                <div className="text-sm text-slate-700 font-medium" data-id="element-348">
                  🇵🇭 Philippines
                </div>
                <div className="text-sm text-slate-700 font-medium" data-id="element-349">
                  🇰🇭 Cambodia
                </div>
                <div className="text-sm text-slate-700 font-medium" data-id="element-350">
                  🇱🇦 Laos
                </div>
                <div className="text-sm text-slate-700 font-medium" data-id="element-351">
                  🇲🇲 Myanmar
                </div>
                <div className="text-sm text-slate-700 font-medium" data-id="element-352">
                  🇸🇬 Singapore
                </div>
                <div className="text-sm text-slate-700 font-medium" data-id="element-353">
                  🇧🇳 Brunei
                </div>
              </div>
            </div>
          </div>
        </Card>
      </PageLayout>
    </>;
}